module.exports = __webpack_public_path__ + "static/sponsorship_img-07-d@2x-b59755fce8136c8277b9618fb861322a.jpg";